<script setup lang="ts">
defineProps<{
  label: string
  name: string
  pattern?: string
  placeholder?: string
  required?: boolean
}>()

const phoneInput = ref<HTMLInputElement | null>(null)

const handleKeyDown = (e: HTMLElementEventMap['keydown']) => {
  if (!phoneInput.value) return
  const key = e.key
  const cursorPos = phoneInput.value.selectionStart
  const value = phoneInput.value.value

  const allowedControlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']

  const isDigit = /^[0-9]$/.test(key)
  const isControl = allowedControlKeys.includes(key)

  // Allow only one '+' and only at the beginning
  if (key === '+') {
    if (cursorPos !== 0 || value.includes('+')) {
      e.preventDefault()
      return
    }
  }

  // Prevent multiple consecutive dashes
  if (key === '-' && cursorPos) {
    const before = value[cursorPos - 1]
    const after = value[cursorPos]
    if (before === '-' || after === '-') {
      e.preventDefault()
      return
    }
  }

  if (!isDigit && key !== '+' && key !== '-' && !isControl) {
    e.preventDefault()
  }
}

onMounted(() => {
  phoneInput.value?.addEventListener('keydown', handleKeyDown)
})

onUnmounted(() => {
  phoneInput.value?.removeEventListener('keydown', handleKeyDown)
})
</script>

<template>
  <div class="flex flex-col gap-2 font-mono text-sm uppercase">
    <label :for="name">
      <span>{{ label }} ({{ required ? 'Required' : 'Optional' }})</span>
    </label>

    <input
      :id="name"
      ref="phoneInput"
      :required="required"
      :name="name"
      :placeholder="placeholder"
      pattern="^\+?[0-9\-]*$"
      class="selection:!text-neon-yellow border border-black/50 p-3 selection:!bg-black"
      type="tel"
    />
  </div>
</template>
